<template>
    <div v-show="visible">
        <el-dialog title="导入" :visible.sync="visible" :close-on-click-modal="false" 
            v-loading="loading"
            :before-close="dialogClose"  width="400px">    
            <el-form ref="form" label-width="70px">

                <el-form-item   prop="deviceSysId" label="导入学校">
                    <el-select v-model="form.deptId" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                
                <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :show-file-list="false"
                    :auto-upload="true"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload">
                    <el-button size="small" type="primary">点击导入人员数据</el-button>&nbsp;&nbsp;
                    <div slot="tip" class="el-upload__tip" style="font-size:12px;color:#BBBBBB">
                        &nbsp;&nbsp;&nbsp;&nbsp;点击“下载模板”按钮，根据模板格式填写用户信息，然后再进行点击导入，注意点如下：<br/>
                        1、姓名、性别、人员类型属于必填项，其他字段针对不同的人员类型，而不同。<br/>
                        2、人员类型属于学生：年段、班级必填，其他可选。年段和班级名称必须和组织机构中的名称一致。<br/>
                        3、人员类型属于教职：组织名称、手机号码必填，其他可选。组织名称必须和组织机构中的名称一致。手机号码填入在校通讯录的手机号码，此号码需和钉钉账号的手机号码一致。<br/>
                    </div>
                </el-upload>
                <br/>
                <el-button size="small" type="info" @click="downLoad">下载模板</el-button>
            </el-form>
        </el-dialog> 
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import saveAs from 'file-saver';

    export default {
        data(){
            return{
                visible: false,
                loading:false,
                fileList: [],
                uploadUrl:"",
                depts:[],
                form:{
                    deptId:""
                }
            }
        },
        created:function () {
        },
        methods:{
             init(){
                this.visible = true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.uploadUrl=this.userImportUserUrl;

                // 初始学校数据
                this.getDepts();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            handleAvatarSuccess(res, file) {
                //this.imageUrl = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {
                let fileType = file.type
                let isLt2M = file.size / 1024 / 1024 < 100;
                console.log("文件类型："+fileType+";文件大小："+file.size)
                if(this.$constant.excelFileType.indexOf(fileType) == -1){
                    this.$commonFn.showTip('导入文件只支持.xls与.xlsx', 3)
                    return false
                }

                if (!isLt2M) {
                    this.$commonFn.showTip('文件大小不能超过100MB!', 3)
                    return false
                }
                // console.log(file.size+"；文件："+isLt2M);
                // 上传文件
                this.loading=true
                let uploadForm=new FormData()
                uploadForm.append('file', file)
                uploadForm.append('deptId', this.form.deptId)
                this.$axios.post(this.userImportUserUrl, uploadForm).then((res) => {
                    // console.log("文件反馈:"+JSON.stringify(res.data))
                    if(res.data.status == 200){
                        this.$commonFn.showTip(res.data.message, 4,true)
                        this.visible=false
                        this.$parent.getData()
                    }else{
                        this.$commonFn.showTip(res.data.message, 3)
                    }
                    this.loading=false
                }, (err) => {
                    console.log(err)
                    this.loading=false
                    this.$commonFn.showTip("网络繁忙，请稍后重试，响应码("+err.response.status+")", 3)
                });
            },
            downLoad(){
                var fileSaver = require('file-saver');
                fileSaver.saveAs("../../../../static/user.xlsx","人员名单模板.xlsx");
            },
            getDepts(){ // 获取学校
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/page/sys/user/ImportUser.vue